import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@shared/lib';

type ChipVariant = 'default' | 'accent' | 'ghost' | 'success' | 'due' | 'fresh';

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  showDot?: boolean;
  children: ReactNode;
}

const variants: Record<ChipVariant, string> = {
  default: 'bg-elev text-fg',
  accent: 'bg-accent text-fg-inv',
  ghost: 'bg-transparent border border-line text-muted',
  success: 'bg-success/15 text-success',
  due: 'bg-accent/15 text-accent',
  fresh: 'bg-elev text-fg',
};

export function Chip({ variant = 'default', showDot, className, children, ...rest }: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-pill px-3 py-1 text-xs font-medium tracking-[0.02em]',
        variants[variant],
        className,
      )}
      {...rest}
    >
      {showDot && <span className="h-1.5 w-1.5 rounded-pill bg-current" />}
      {children}
    </span>
  );
}
